export default {
  // ========== Buttons and actions ==========
  openInNewTab: 'Open in new tab',

  // ========== Subject Language ==========
  matterLanguageLabel: '{entity} Language',

  // ========== Section titles ==========
  programs: 'Programs',
  subjectDescription: 'Subject Description',
  evaluation: 'Evaluation',
  learningExperiences: 'Learning Experiences',
  piaCampus: 'PIA Campus',
  paStudent: 'PA Student',
  pdaTeacher: 'PDA Teacher',
  bibliographicResources: 'Bibliographic Resources',

  // ========== Informative messages ==========
  tributesToCompetences: 'to which the',
  doesNotTribute: 'This {entity} does not contribute to any',

  // ========== Informative tooltips ==========
  defaultDescriptorInfo: 'If default is selected, the descriptor statement will be enabled in other Programs.',
  notFoundResourcesWarning: 'No Bibliographic Resources found with the Code of the',

  // ========== Delete confirmations ==========
  deleteTitleConfirm: 'Are you sure you want to delete the descriptive title?',
  deleteTitleWarning: 'This action cannot be undone and will delete the objects referenced below.',
  deleteContentConfirm: 'Are you sure you want to delete the content of the descriptive title?',
  affectOthersWarning: 'This action cannot be undone and could affect other',
  moveSectionConfirm: 'Are you sure you want to move the descriptive title to this section?',
  moveSectionWarning: 'The section belongs to the descriptive title: it will move in the program of every {entity} that uses it.',
  moveSectionLocked: 'This descriptive title belongs to the system and cannot change section.',

  // ========== Close confirmations ==========
  closeSubjectConfirm: 'Are you sure you want to close the',
  closeSubjectWarning: 'Considering that you have not assigned any',

  // ========== Success messages ==========
  descriptorCreated: 'Descriptor created.',
  descriptorUpdated: 'Descriptor updated.',
  subjectUpdated: 'updated.',
  competencesUpdated: 'updated.',
  descriptionUpdated: 'Description of {entity} updated.',

  // ========== Form labels ==========
  title: 'Title',
  content: 'Content',
  assign: 'Assign a',
  toThe: 'to the',
  inTheSection: 'in the section',
  without: 'without',
  without2: 'Without',

  // ========== Time Allocation Component ==========
  enterDataBy: 'Enter data by:',
  week: 'Week',
  total: 'Total',
  pedagogicalHours: 'Pedagogical Hours',
  includeIn: 'Include in {entity}',
  attendancePercentageRequired: 'Required attendance percentage',
  studentsPerHour: 'No. of students',
  fieldNotEmptyAndNotLessThanZero: 'This field must not be empty and must not be less than 0.',
  minutesPerPedagogicalHourFormula: '{entity1}({value1}) * Minutes per Pedagogical Hour({value2}/60)= {result}',

  // ========== Info Evaluations Component ==========
  allEntitiesComplete: 'All {entity} are complete.',
  incompleteEntities: 'Incomplete {entity}',
  requireCompleteTheseEntities: 'Requires completing these {entity}.',
  entitiesToClose: '{entity} to Close',
  mustCloseTheseEntities: 'You must close these {entity}.',
  closeEntities: 'Close {entity}',
  openEntities: 'Open {entity}',
  clickToUpdateData: 'Click to update data.',
  updateData: 'Update Data',
  goDirectlyTo: 'Go directly to {entity}',
  ilNotMentioned: 'IL not mentioned',
  mustIncludeAllEntitiesInActivities: 'You must include all {entity1} in Activities/{entity2}.',
  entityDoesNotHaveAnyEvaluationCreated: 'The {entity} does not have any evaluation created.',
  evaluationDoesNotHaveEntity: 'The evaluation does not have {entity}.',

  // ========== Matter Presentation Component ==========
  planLevel: 'plan level',
  prerequisite: 'prerequisite',
  prerequisites: 'prerequisites',
  doesNotHave: 'Does not have',
  requirements: 'Requirements',
  weeks: 'weeks',
  numberOfTeachers: 'No teachers',
  isExemptable: 'exemptable',
  autonomousWorkHours: 'autonomous work hours',
  publicationDate: 'publication date',
  pmdStatus: 'pmd status',
  notStarted: 'Not started',
  inProgress: 'In progress',
  completed: 'Completed',
  activityType: 'activity type',
  attendanceRequirement: 'attendance requirement',
  weekly: 'weekly',
  includeInCountable: 'Include in {entity} countable',
  notIncludeInCountable: 'Not include in {entity} countable',
  publicationDateUpdated: 'Publication Date Updated',

  // ========== Evaluation Criteria Macro Component ==========
  entityDoesNotHaveEntity: 'This {entity1} does not have {entity2}',
  weighing: 'Weighing',
  contents: 'Contents',

  // ========== Evaluation Criteria Macro Form ==========
  addCriteria: 'Add criteria',
  weighingLimitReached: 'The 100% weighing limit has been reached.',
  noEntity: 'There is no {entity}',
  entityDeleted: '{entity} deleted.',
  weighingDescription: 'Weighing with respect to the Learning Result.',
  testWeighingOf: 'Weighing of the {entity}',
  available: 'Available',
  requiredFieldMaxValue: 'This field is required and must not exceed {max}.',
  requiredFieldBetweenValues: 'This field is required and must be between {min} and {max}.',

  // ========== EC Macro Content Component ==========
  addContentsSeparately: 'Add contents separately',
  cannotSaveIfEmpty: 'Cannot save if empty.',

  // ========== Methodological Strategies Row Component ==========
  multiSelectInfo: 'To select multiple items, hold down the Ctrl key and then select the items you want.',
  coloredMinimumEntitiesStart: 'The',
  coloredMinimumEntitiesColored: 'colored',
  coloredMinimumEntitiesEnd: '{entity1} defined as minimum for the {entity2} are shown',
  minimumEntitiesOf: 'Minimum strategies of the {entity}',

  // ========== Matter Capacities Component ==========
  noAssociatedEntityToShow: 'There is no {entity} associated to show.',

  // ========== Competence Units Component ==========
  totalHours: 'Total hours',
  hours: 'Hours',
  numberAbbreviation: 'No. ',
  cannotAddEntityClosedEvaluations: 'Cannot add {entity} since there are closed evaluations. If you still want to add {entity} press the button and open the evaluations that will be indicated in the window.',
  closedEvaluations: 'Closed evaluations',

  // ========== UnitSection Component ==========
  addContentsSeparately2: 'Add {entity} separately',

  // ========== Info Test Table Component ==========
  criteria: 'Criteria',
  complies: 'Complies',
  problems: 'Problem(s)',
  reviewWeighingsOf1: 'Review the weighings of the {entity}',
  reviewWeighingsOf2: 'Review the weighings of the {entity}',
  existing: 'existing',
  mustCreateA: 'A {entity} must be created',
  hasFieldSelected: 'Has the field {entity} selected',
  mustSelectInForm: 'A {entity} must be selected in the form',
  noInconsistencies: 'No inconsistencies',
  exists: '{entity} exists',
  weighingOfEntitySums100: 'The weighing of the {entity} adds up to 100%',
  allEntitiesContributeTo: 'All the {entity1} contribute to the {entity2}',
  sumOfWeighingsDoesNotMatch: 'The sum of weighings of the {entity1} does not match the {entity2}',

  // ========== ECM Info Table Component ==========
  mentions: 'Mentions',
  notMentionedInAnyActivityEvaluation: 'Not being mentioned in any Activity/Evaluation',
  activities: 'Activities',
  activity: 'Activity',

  // ========== Linking Competence To Ra Component ==========
  linkEntityCreatedToEntity: 'Link created {entity1} to the {entity2}',
  entityLinkedToEntity: '{entity1} linked to the {entity2}',
  linked: 'linked',
  unlinked: 'unlinked',

  // ========== Evaluation Criteria Component ==========
  equivalentWeighing: 'Equivalent Weighing',
  cannotChangeEquivalentWeighing: 'Cannot change the Equivalent Weighing as there are closed evaluations. If you still wish to change the Weighing, press the button and open the Evaluations that will be indicated in the window',
  weighingLimitReached100: 'The 100% weighing limit has been reached',
  cannotAddEntitiesClosedEvals: 'Cannot add {entity} as there are closed evaluations. If you still want to add {entity} press the button and open the Evaluations that will be indicated in the window',
  cannotDeleteEntitiesClosedEvals: 'Cannot delete {entity} as there are closed evaluations. If you still want to delete {entity} press the button and open the Evaluations that will be indicated in the window',
  performanceIndicatorOfGenericCompetencies: 'Performance Indicator of GC',
  deleted: 'Deleted',

  // ========== Matter Program Evaluation Component ==========
  workTypesOf: 'Work types of',
  summative: 'Summative',
  activitiesAndEvaluations: 'Activities and Evaluations',
  createActivityOrEvaluation: 'Create Activity or Evaluation',
  type: 'Type',
  directTeachingHours: 'Direct Teaching Hours (Pedagogical Hours)',
  autonomousWorkHours2: 'Autonomous Work Hours (Chronological Hours)',
  chronologicalHours: 'Chronological Hours',
  totalOfSubject: 'Total {percent}% of the Subject',
  noActivitiesOrEvaluationsToShow: 'No activities or evaluations to show',
  unsavedDataWillBeLost: 'Are you sure you want to close? Unsaved data will be lost',
  confirmationRequired: 'Confirmation Required',
  yesClose: 'Yes, close',

  // ========== Copy Evaluations ==========
  copyEvaluations: 'Copy Evaluations',
  copyEvaluationsModalTitle: 'Copy Evaluations',
  copyEvaluationsFrom: 'Copy from {entity}',
  copyEvaluationsTo: 'Copy to {entity}',
  copyEvaluationsToEpm: 'Copy to the {entity} of another {entity2}',
  copyEvaluationsFromEpm: 'Copy from the {entity} of another {entity2}',
  copyEpmToEpmDesc: 'The evaluations of this {entity} will be exported to the {entity} of the target {entityProfile} you select. The current evaluations of the target will be deleted and replaced by those of this {entity}. <strong>Requirement:</strong> both {entity} must have the "Link Base Subject" option set to <strong>No</strong>.',
  copyEpmFromEpmDesc: 'The evaluations of the selected source {entity} will be imported into this {entity}. The current evaluations of this {entity} will be deleted and replaced. <strong>Requirement:</strong> both {entity} must have the "Link Base Subject" option set to <strong>No</strong>.',
  copyEpmToMatterDesc: 'The evaluations of this {entity} will be exported to the {entityMatter}. The current evaluations of the {entityMatter} will be deleted and replaced. This change may affect other {entityEpm} that are linked to the {entityMatter}.',
  copyMatterToEpmDesc: 'The evaluations of the {entityMatter} will be imported into this {entity}. The current evaluations of this {entity} will be deleted and replaced by those of the {entityMatter}.',
  exportMatterToEpmDesc: 'The evaluations of this {entityMatter} will be exported to the {entity} of the selected {entityProfile}. The current evaluations of the {entity} will be deleted and replaced. <strong>Requirement:</strong> the {entity} must have the "Link Base Subject" option set to <strong>No</strong>.',
  importEpmToMatterDesc: 'The evaluations of the {entity} of the selected {entityProfile} will be imported into this {entityMatter}. The current evaluations of this {entityMatter} will be deleted and replaced. This change may affect other {entity} linked to this {entityMatter}.',
  selectTargetEpm: 'Select the target {entity}',
  copyOptionEpmToEpm: 'From another {entity} of the same type',
  copyOptionEpmToMatter: 'To the {entity}',
  copyOptionMatterToEpm: 'From the {entity}',
  selectSourceEpm: 'Select the source {entity}',
  swapDirection: 'Swap direction',
  copyWithOtherEpm: 'With another {entity2}',
  copyWithMatter: 'With {entity}',
  copyEpmEpmModalTitle: 'Import/Export to another {entity}',
  copyEpmMatterModalTitle: 'Import/Export to {entity}',
  copyEvaluationsConfirm: 'This action will replace all current evaluations in the target and cannot be undone. Do you want to continue?',
  copyEvaluationsConfirmAddOnly: '{count} evaluation(s) will be added to the target. This action cannot be undone. Do you want to continue?',
  copyEvaluationsConfirmAddAndDelete: '{countAdd} evaluation(s) will be added to the target and {countDelete} evaluation(s) will be deleted from the target. This action cannot be undone. Do you want to continue?',
  copyEvaluationsSuccess: 'Evaluations copied successfully.',
  copyEvaluationsError: 'Error copying evaluations.',
  noEpmAvailableTitle: 'There is no available target for this operation',
  noEpmAvailableToCopy: 'This {entity} does not exist in any other {entityProfile} with its own evaluations, so there is no target to copy them to. That is why the {entityProfile} selector is not shown and the operation cannot continue.',
  noEpmAvailableHint: 'To enable this option, the {entity} must also exist in another {entityProfile}, and that record must have the "Link Base Matter" option set to No (if it is set to Yes, that {entity} uses the evaluations of the {entityMatter} and cannot receive a copy).',
  evaluationsToBecopied: 'Evaluations to Export (Source)',
  evaluationsToBeImported: 'Evaluations to Import (Source)',
  evaluationsToBeReplaced: 'Evaluations to be Updated (Target)',
  noEvaluationsInSource: 'No evaluations in source.',
  noEvaluationsInTarget: 'No evaluations in target.',
  loadingPreview: 'Loading preview...',
  summaryToAdd: 'Evaluation(s) to add',
  summaryToDelete: 'Evaluation(s) to delete',
  previewColumnHeader: 'Preview (Result)',
  previewColumnEmpty: 'Select evaluations to see the result.',
  previewTotal: 'Total weighing',
  previewTotalExceeded: 'The sum of weighings exceeds 100%.',
  previewGroupTransversal: 'Transversal Exam',
  previewNew: 'New',
  previewExisting: 'Remains',
  belongsToProfile: 'Egress Profile: {profile}',
  sourceLabel: 'Source',
  targetLabel: 'Target',
  copyFromMatter: 'Copy from {entity}',

  // ========== Estado de contenido de la Evaluación ==========
  hasContent: 'Complete',
  evaluationHasContent:
    '{entity1} content is complete: the questions of each {entity2} add up to its total score and each {entity3} adds up to 100%.',
  evaluationHasNoContent:
    '{entity1} content is incomplete: content is missing, or the {entity2} question scores / {entity3} weightings do not add up.',
  ecMicroInUse: 'In use in the content of the evaluation.',
  ecMicroNotInUse: 'Assigned, but not used in the content of the evaluation.',

  // ========== IL Indicators Usage Component ==========
  writtenInstruments: 'Written Instruments',
  observationInstruments: 'Observation Instruments',
  notMentionedInAnyEvaluation: 'Not being mentioned in any Evaluation',
  summaryOfEntitiesEvaluatedIn: 'Summary of {entity1} evaluated in the {entity2}',
  totalOf: 'Total of',
  notMentioned: 'Not mentioned',
  totalQuestions: 'Total Questions',
  totalQuestionsNotAssociatedWith: 'Total Questions not associated with {entity}',
  totalOfEntitiesInObservationInstruments: 'Total {entity} in Observation Instruments',
  entitiesNotAssociatedWith: '{entity1} not associated with {entity2}',

  // ========== Study Unit Form ==========
  details: 'Details',
  suggestedHours: 'Suggested Hours',
  lockEntity: 'Lock {entity}',
  unlockEntity: 'Unlock {entity}',
  currentlyUnlocked: 'Currently the {entity} is unlocked',
  currentlyLocked: 'Currently the {entity} is locked',
  weighingAvailableIs: 'Available weighing is:',
  hoursAvailableIs: 'Available hours are:',
  requiredFieldMaxHours: 'This field is required and must not exceed the {max} total pedagogical hours.',
  cannotChangeWeighingClosedEvals: 'Cannot change weighing as there are closed evaluations.',
  toChangeWeighingInstructions1: 'If you still wish to change the weighing, click on',
  toChangeWeighingInstructions2: 'and open the evaluations that will be indicated in the window.',
  seeMore: 'see more',
  noCreatedEntitiesFeminine: 'No {entity} created',
  goToCurricularDefinitionsToCreate: 'Go to Curricular Definitions to create {entity}.',
  noEntitiesInSelected: 'No {entity1} available in the selected {entity2} for that {entity3}.',
  cannotDeleteEntityClosedEvals: 'Cannot delete the {entity} as there are closed Evaluations. If you still want to delete the {entity} press the button and open the Evaluations that will be indicated in the window.',
  selectAnOption: '-- Select one of the options --',
  writing: 'Writing',
  deletePerformanceIndicator: 'Delete Performance Indicator',
  missingFields: 'Missing fields',
  ensureCompleteFields: 'Please make sure to complete the fields.',
  orderRepeatedConfirm: 'The order of the Unit is repeated, do you want to continue saving?',
  orderMismatchWarning: 'This action will cause the order of the Units to be misaligned!',
  cannotSaveEntities: 'Cannot save {entity}',
  entityNotYetSaved: 'The {entity} has not been saved yet.',
  confirmUnlinkEntity: 'Are you sure you want to remove the link with the {entity1} from the {entity2}?',
  unlinkWarningText: 'By applying this, the {entity1} becomes independent of the {entity2}. If the latter is modified, the change will not be reflected in the {entity1}',
  specifyWeeksDescription: 'Specify the weeks the Learning Unit will take.',
  specifyWeighingFor: 'Specifies the percentage of contribution to the {entity}.',
  specifyPositionDescription: 'You can specify the position or order.',
  requiredFieldMaxWeighing: 'This field is required and must not exceed {max}%.',
  mustSelect: 'You must select a {entity}.',
  link: 'Link',
  apply: 'Apply',
  nameFieldDescription: 'You can add a name to the {entity}.',
  genericPerformanceIndicator: 'Generic Competence Performance Indicator',
  selectEntityTooltip: 'Select an already created {entity1} from the {entity2}.',

  // ========== Matter Program Evaluation Draggable Component ==========
  editBibliographicResources: 'Edit Bibliographic Resources',
  editActivityEvaluation: 'Edit Activity/Evaluation',
  deleteActivityEvaluation: 'Delete Activity/Evaluation',
  confirmDeleteEntity: 'Are you sure you want to delete {entity}?',
  hrs: 'Hrs',
  the: 'the',
  theEvaluation: 'the evaluation',

  // ========== M Evaluation Bibliographic Resource Component ==========
  bibliographicResource: 'Bibliographic Resource',
  createBibliographicResource: 'Create Bibliographic Resource',
  mandatoryBibliography: 'Mandatory Bibliography',
  complementaryBibliography: 'Complementary Bibliography',
  bibliographicResourceDeleted: 'Bibliographic Resource deleted.',
  bibliographicResourceCreated: 'Bibliographic Resource created.',
  bibliographicResourceUpdated: 'Bibliographic Resource updated.',
  fieldMinLength: 'This field must have at least {min} characters.',

  // ========== Matter Program Evaluation Form Component ==========
  descriptionForStudent: 'Description for Student',
  activityOrEvaluation: 'Activity or Evaluation',
  evaluativeAgent: 'Evaluative Agent',
  workType: 'Work Type',
  examiner: 'Examiner',
  numberOfStudents: 'No of Students',
  autonomousWorkActivityStudent: 'Autonomous Work Activity of the Student',
  supportResources: 'Support Resources',
  mustBeGreaterThanZeroAnd: 'Must be greater than 0 and',
  mustNotExceed: 'Must not exceed',
  thisFieldIsRequired: 'This field is required.',
  createSupportResource: 'Create Support Resource',
  createdFeminine: 'created',
  editDescriptionForStudent: 'Edit Description for Student',
  editDescriptionOf: 'Edit Description of the {entity}',
  selectOneOrMoreEvaluativeAgents: 'Select one or more Evaluative Agents',
  noEvaluativeAgents: 'No Evaluative Agents available',
  selectOneOrMoreAutonomousActivities: 'Select one or more Autonomous Work Activities',
  noAutonomousActivities: 'No Autonomous Work Activities available',
  addSupportResources: 'Add Support Resources',

  // ========== Test Component ==========
  actionCannotBeRevertedOnSave: 'This action cannot be undone upon saving!',

  // ========== Mat Eva Stu Env Tim All Input Component ==========
  hoursNotAssociatedWith: 'These are hours not associated with the selected {entity}.',
  surplus: 'Surplus',
  deleteHour: 'Delete Hour',

  // ========== Learning Experience Component ==========
  deleteLearningExperienceConfirm: 'Are you sure you want to delete the {entity}?',
  evaluations: 'Evaluations',

  // ========== Assistant Profile Component ==========
  assistantProfileFor: 'Assistant profile for the {entity}',
  assistantProfile: 'Assistant profile',
  assistantRole: 'Assistant role',
  addNewAssistantProfile: 'Add a new assistant profile',
  deleteAssistantProfile: 'Delete assistant profile',
  editAssistantProfile: 'Edit assistant profile',
  editAssistantRole: 'Edit assistant role',
  assistantProfileCreated: 'Assistant profile created.',
  assistantProfileUpdated: 'Assistant profile updated.',
  deleteAssistantProfileConfirm: 'Are you sure you want to delete the assistant profile?',
  assistantProfileDeleted: 'Assistant profile deleted.',

  // ========== Teaching Profile Component ==========
  teachingProfile: 'Teaching profile',
  addNewTeachingProfile: 'Add a new teaching profile',
  editTeachingProfile: 'Edit teaching profile',
  deleteTeachingProfile: 'Delete teaching profile',
  createTeachingProfile: 'Create teaching profile',
  theoryHours: 'Theory hours',
  practicalHours: 'Practical hours',
  nonAttendanceHours: 'Non-attendance hours',
  professionalExperienceYears: 'Years of professional experience',
  professionalExperienceYearsTooltip: 'Years of work experience in the area.',
  teachingProfileCreated: 'Teaching profile created.',
  teachingProfileUpdated: 'Teaching profile updated.',
  deleteTeachingProfileConfirm: 'Are you sure you want to delete the teaching profile?',
  teachingProfileDeleted: 'Teaching profile deleted.',

  // ========== Bibliographic Resources Component ==========
  canAddUpTo: 'You can add up to {max} Bibliographic Resources',
  addResourcesSeparately: 'Add resources separately',
  editBibliographicResource: 'Edit Bibliographic Resource',
  exceededMaxBibliographicResources: 'Exceeded the maximum number of Bibliographic Resources',
  deleteBibliographicResourceConfirm: 'Are you sure you want to delete the {type} Bibliography?',

  // ========== Resources Learning Environment Component ==========
  resourcesByLearningEnvironment: 'Resources by learning environment (FER Form Reference)',
  editResourcesByLearningEnvironment: 'Edit resources by learning environment (FER form Reference)',
  resourcesByLearningEnvironmentUpdated: 'Resources by learning environment (FER form Reference) updated.',

  // ========== Teaching Support Resources Component ==========
  teachingSupportResources: 'Teaching support resources',
  createResource: 'Create resource',
  editTeachingSupportResource: 'Edit teaching support resource',
  deleteInstanceConfirm: 'Are you sure you want to delete this instance of "{type}"?',
  teachingSupportResourceDeleted: 'Teaching support resource deleted.',
  teachingSupportResourceUpdated: 'Teaching support resource updated.',
}
